import { ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button, { Props as ButtonProps, Color } from 'atoms/buttons/Button';
import useToggleSubscription from 'hooks/subscriptions/useToggleSubscription';
import useLoggedCallback from 'hooks/useLoggedCallback';
import { glossary } from 'lib/glossary';

interface Props
  extends Omit<ButtonProps, 'onChange' | 'classes' | 'onClick' | 'size'> {
  currentUserSubscription: { slug: string } | null | undefined;
  subscribable: { __typename: string; slug: string };
  onChange?: (value: boolean) => void;
  onClick?: (value: boolean) => void;
  followCopy?: ReactNode;
  followingCopy?: ReactNode;
}

const Root = styled(Button)`
  &.stroke {
    background-color: white;
  }
`;

export const FollowButton = (props: Props) => {
  const {
    currentUserSubscription,
    subscribable,
    onChange,
    onClick,
    className,
    followCopy,
    followingCopy,
    ...rest
  } = props;
  const [hover, setHover] = useState(false);
  const toggleSubscription = useToggleSubscription(
    currentUserSubscription,
    subscribable
  );
  const callback = () => {
    onChange?.(!currentUserSubscription);
    toggleSubscription();
  };
  const loggedToggleSubscription = useLoggedCallback(callback, true);

  let btnColor: Color = 'primary';
  if (currentUserSubscription && hover) {
    btnColor = 'red';
  } else if (currentUserSubscription) {
    btnColor = 'secondary';
  }

  return (
    <Root
      onClick={e => {
        onClick?.(!currentUserSubscription);
        loggedToggleSubscription(e);
      }}
      className={className}
      color={btnColor}
      size="medium"
      onMouseEnter={() => {
        if (currentUserSubscription) setHover(true);
      }}
      onMouseLeave={() => {
        if (currentUserSubscription) setHover(false);
      }}
      {...rest}
    >
      <span>
        {currentUserSubscription
          ? followingCopy || (
              <FormattedMessage
                {...(hover ? glossary.unfollow : glossary.followed)}
              />
            )
          : followCopy || <FormattedMessage {...glossary.follow} />}
      </span>
    </Root>
  );
};

export default FollowButton;
